import DarkButton from '@/components/ui/Buttons/SecondaryButton'
import useIntl from '@/utils/intl'
import classNames from 'classnames'
import Image from 'next/image'
import { FunctionComponent, useState } from 'react'
interface Props {
  onClick: (type: string) => void
}

const Step0: FunctionComponent<Props> = ({ onClick }) => {
  const { translate } = useIntl()
  const [clicked, setClicked] = useState(0)
  const BILL_TYPES = [
    {
      title: translate('bill.mobicom'),
      img: '/images/mobicom.png',
      type: 'MOBICOM_BILL'
    },
    {
      title: translate('bill.mobinet'),
      img: '/images/mobinet.png',
      type: 'MOBINET_BILL'
    },
    {
      title: translate('bill.Mnp75'),
      img: '/images/mnp75.png',
      type: 'MNP75_BILL'
    },
    {
      title: translate('bill.Voo'),
      img: '/images/voo.png',
      type: 'VOO_BILL'
    }
  ]

  const handleNext = (): void => {
    onClick(BILL_TYPES[clicked].type)
  }
  return (
    <div className='bg-surfaceInverse rounded-xl md:shadow w-full h-full md:h-[75vh] md:w-fit flex flex-col justify-start overflow-auto relative'>
      <div className='md:p-8 p-4 flex-grow overflow-auto'>
        <span className='text-textHigh text-lg font-bold'>{translate('service.select')}</span>
        <div className='flex flex-col gap-4 mt-6'>
          {
            BILL_TYPES.map((item, i) => (
              <div key={i} className={classNames('md:w-96 px-3 py-2 flex justify-between items-center border bg-surfaceWebGrey rounded-xl cursor-pointer hover:border-primaryMainStroke', (clicked === i ? ('border-primaryMainStroke') : 'border-secondaryMidStroke'))} onClick={() => setClicked(i)}>
                <div className='flex justify-center gap-3 items-center'>
                  <Image draggable={false} width={100} height={100} alt='img' className='w-10 h-10 object-contain' src={item.img} />
                  <span className='text-textHigh text-sm font-bold w-52'>{item.title}</span>
                </div>

              </div>
            ))
          }
        </div>
        {/* <p className={classNames('text-sm text-[#FF0000] py-1 pl-2', state.amountError !== undefined && state.amountError ? 'visible' : 'invisible')}>1000 төгрөгөөс доош дүнтэй гүйлгээ хийх боломжгүй.</p> */}
      </div>
      <div className='fixed md:sticky bottom-0 right-0 left-0 z-50 md:p-6 p-4 border-t bg-surfaceInverse border-secondaryMidStroke'>
        <DarkButton fullwidth onClick={handleNext}>{translate('continue')}</DarkButton>
      </div>
    </div>
  )
}
export default Step0
